import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Admin from "../views/AddAdmin.vue";
import Billing from "../views/Billing.vue";
import Profile from "../views/Profile.vue";
import Signup from "../views/Signup.vue";
import Signin from "../views/Signin.vue";
import Users from "../views/Users.vue";
import Filter from "../views/Filter.vue";
import Subscriptions from "../views/Subscriptions.vue";

function guardMyroute(to, from, next) {
    if (localStorage.getItem('auth-token'))
        next();
    else
        next('/signin');
}

const routes = [{
        path: "/",
        name: "/",
        redirect: "/dashboard",
    },
    {
        path: "/dashboard",
        name: "Dashboard",
        component: Dashboard,
        beforeEnter: guardMyroute
    },
    {
        path: "/new-admin",
        name: "Add Admin",
        component: Admin,
        beforeEnter: guardMyroute
    },
    {
        path: "/billing",
        name: "Billing",
        component: Billing,
        beforeEnter: guardMyroute

    },
    {
        path: "/profile",
        name: "Profile",
        component: Profile,
        beforeEnter: guardMyroute

    },
    {
        path: "/signin",
        name: "Signin",
        component: Signin,
    },
    {
        path: "/signup",
        name: "Signup",
        component: Signup,
    },
    {
        path: "/users",
        name: "Users",
        component: Users,
        beforeEnter: guardMyroute

    },
    {
        path: "/subscriptions",
        name: "Subscriptions",
        component: Subscriptions,
        beforeEnter: guardMyroute

    },
    {
        path: "/filter",
        name: "Filter",
        component: Filter,
        beforeEnter: guardMyroute

    },

];

const router = createRouter({
    history: createWebHistory(),
    routes,
    linkActiveClass: "active",
});

export default router;